module.exports = __webpack_public_path__ + "static/media/Background Banner.a2c5943e.png";